<template>
  <div class="login-overlay">
    <!-- 登录窗口 -->
    <div class="login-page" v-if="show">
      <i class="el-icon-circle-close" @click="close"></i>
      <div class="login-page_header">
        <img src="@/assets/images/wecomeCenter.png" />
      </div>
      <div class="login-form">
        <el-form key="logoFormKey" :model="logoForm" :rules="logoFormRule" ref="logoFormRef" class="login-ruleForm"
          @keyup.enter.native="loginFn">
          <el-form-item label="" prop="phone">
            <el-input name="logo-phone" v-model="logoForm.phone" :placeholder="$t('loginI18n.logoForm.phone')">
              <template #prefix>
                <img src="../assets/images/login_icon_phone.png" class="login-form_user" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="phone_msg" style="margin-bottom: 13px;">
            <el-input name="logo-phone_msg" :type="showPassword ? 'text' : 'password'" v-model="logoForm.phone_msg"
              :placeholder="$t('loginI18n.logoForm.phone_msg')">
              <template #suffix>
                <img src="../assets/images/login_icon_view.png" class="login-form_view"
                  @click="togglePasswordVisibility" />
              </template>
              <template #prefix>
                <img src="../assets/images/login_icon_password.png" class="login-form_user" />
              </template>
            </el-input>
          </el-form-item>
          <div class="forget_password">
            <div></div>
            <div @click="forgetPassword">{{ $t('loginI18n.logoForm.forgetPassword') }}?</div>
          </div>
          <div class="login-form_button">
            <el-button class="login-form_button_btn register" :class="$i18n.locale == 'en' ? 'noLetter' : ''"
              type="primary" @click="switchToRegister">{{ $t('loginI18n.logoForm.register') }}</el-button>
            <el-button class="login-form_button_btn login" :class="$i18n.locale == 'en' ? 'noLetter' : ''"
              :disabled="disabled" type="primary" @click="loginFn">{{ $t('loginI18n.logoForm.login') }}</el-button>
          </div>
          <!-- <div class="login-form_info">请联系公司邮箱申请账号：customerservice@carbonneutrality-group.com</div> -->
        </el-form>
      </div>
    </div>
    <!-- 注册窗口 -->
    <div class="register-page" v-else>
      <i class="el-icon-circle-close" @click="switchToLogin"></i>
      <div class="login-page_header">
        <img src="@/assets/images/wecomeCenter.png" />
      </div>
      <div class="login-form">
        <el-form key="registerFormKey" :model="registerForm" :rules="registerFormRule" autocomplete="off"
          ref="registerFormRef" class="register-ruleForm">
          <el-form-item label="" prop="user_name">
            <el-input v-model="registerForm.user_name" name="register-company" autocomplete="register-company"
              :placeholder="$t('loginI18n.registerForm.user_name')">
              <template #prefix>
                <img src="../assets/images/login_icon_company.png" class="login-form_company" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="company">
            <el-input v-model="registerForm.company" name="register-company" autocomplete="register-company"
              :placeholder="$t('loginI18n.registerForm.company')">
              <template #prefix>
                <img src="../assets/images/login_icon_company.png" class="login-form_company" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="email">
            <el-input v-model="registerForm.email" name="register-email" autocomplete="register-email"
              :placeholder="$t('loginI18n.registerForm.email')">
              <template #prefix>
                <img src="../assets/images/login_icon_phone.png" class="login-form_email" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="phone">
            <el-input class="hide-spin" autocomplete="new-phone" name="new-phone" v-model="registerForm.phone"
              :placeholder="$t('loginI18n.registerForm.phone')">
              <template #prefix>
                <img src="../assets/images/login_icon_telephone.png" class="login-form_company" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="security_code">
            <div class="register-page_code">
              <el-input class="hide-spin" autocomplete="new-security_code" name="new-security_code"
                v-model="registerForm.security_code" :placeholder="$t('loginI18n.registerForm.code')">
                <template #prefix>
                  <img src="../assets/images/login_icon_safe.png" class="login-form_company" />
                </template>
              </el-input>
              <el-button class="register-page_code_btn" type="primary" :disabled="countdown > 0"
                @click="startCountdown">
                {{ countdown > 0 ? `${countdown}s` : $t('loginI18n.registerForm.codeSend') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input v-model="registerForm.password" autocomplete="new-p" name="new-p"
              :type="showPassword ? 'text' : 'password'" :placeholder="$t('loginI18n.registerForm.password')">
              <template #suffix>
                <img src="../assets/images/login_icon_view.png" class="login-form_view"
                  @click="togglePasswordVisibility" />
              </template>
              <template #prefix>
                <img src="../assets/images/login_icon_password.png" class="login-form_user" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="unPassword">
            <el-input v-model="registerForm.unPassword" autocomplete="new-un" name="new-un"
              :type="showPassword ? 'text' : 'password'" :placeholder="$t('loginI18n.registerForm.unPassword')">
              <template #suffix>
                <img src="../assets/images/login_icon_view.png" class="login-form_view"
                  @click="togglePasswordVisibility" />
              </template>
              <template #prefix>
                <img src="../assets/images/login_icon_password.png" class="login-form_user" />
              </template>
            </el-input>
          </el-form-item>
          <div class="login-form_button">
            <!-- <el-button class="login-form_button_btn register" type="primary" @click="switchToLogin">返回登录</el-button> -->
            <el-button class="register-form_button_btn logo" type="primary" :loading="registerLoading"
              :disabled="registerLoading" :class="$i18n.locale == 'en' ? 'noLetter' : ''" @click="register">
              {{ $t('loginI18n.registerForm.register') }}
            </el-button>
          </div>
          <div class="login-form_info mt-px-20">
            <el-checkbox v-model="agree" @change="handleAgreeChange">
              <span style="color: #757575;">{{ $t('loginI18n.registerForm.agree') }}</span>
              <span style="color: #0095ff;" @click="navigateTo('privacy')">{{ $t('loginI18n.registerForm.privacy')
              }}</span>
            </el-checkbox>
          </div>
        </el-form>
      </div>
    </div>
    <SafeValiate :visible.sync="safeValiate" @close="safeValiate = false" @success="onSafeValidateSuccess" />
    <EPP :editValiate="editValiate" :editType="editType" :newValidation="newValidation" :validationType="validationType"
      :phoneOrEmail="phoneOrEmail" @closeEpp="editValiate = false" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { login, registerApi, sendVerifyCode } from '@/api/index';
import { mapMutations } from 'vuex';
import SafeValiate from './SafeValiate.vue';
import EPP from './EPP.vue';
import { handleLogout } from '@/utils/request';
import { getAccount, } from "@/api";

export default {
  components: {
    SafeValiate,
    EPP
  },
  data() {
    return {
      serviceDialogRef: null,
      show: true,
      showLogin: true,
      showPassword: false,
      logoForm: {
        phone: '',
        phone_msg: ''
      },
      logoFormRule: {
        phone: [
          { required: true, message: this.$t('loginI18n.logoForm.phone'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) return callback();

              // 手机号正则
              const phoneReg = /^1[3-9]\d{9}$/;
              // 邮箱正则
              const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

              if (phoneReg.test(value)) {
                callback(); // 手机号格式正确
              } else if (emailReg.test(value)) {
                callback(); // 邮箱格式正确
              } else {
                callback(new Error(this.$t('loginI18n.logoForm.phone')));
              }
            },
            trigger: 'blur'
          }
        ],
        phone_msg: [
          { required: true, message: this.$t('loginI18n.logoForm.phone_msg'), trigger: 'blur' }
        ]
      },
      registerForm: {
        user_name: "",
        email: "",
        company: "",
        phone: "",
        security_code: "",
        password: "",
        unPassword: ""
      },
      registerFormRule: {
        // user_name: [
        //   { required: true, message: this.$t('loginI18n.registerForm.user_name'), trigger: 'blur' }
        // ],
        // company: [
        //   { required: true, message: this.$t('loginI18n.registerForm.company'), trigger: 'blur' }
        // ],
        // email: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (!value) {
        //         callback(new Error(this.$t('loginI18n.registerForm.email')));
        //       } else {
        //         const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        //         if (!emailReg.test(value)) {
        //           callback(new Error(this.$t('loginI18n.registerForm.emailError')));
        //         } else {
        //           callback(); // 校验通过
        //         }
        //       }
        //     },
        //     trigger: ['blur', 'change'],
        //   },
        // ],
        phone: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t('loginI18n.registerForm.phone')));
              } else {
                const emailReg = /^1[3-9]\d{9}$/;
                if (!emailReg.test(value)) {
                  callback(new Error(this.$t('loginI18n.registerForm.phoneError')));
                } else {
                  callback(); // 校验通过
                }
              }
            },
            trigger: 'blur',
          }
          // { required: true, message: '请输入手机号', trigger: 'blur' },
          // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        security_code: [
          { required: true, message: this.$t('loginI18n.registerForm.code'), trigger: 'blur' },
          { min: 6, max: 6, message: this.$t('loginI18n.registerForm.maxCode'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('loginI18n.registerForm.password'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('loginI18n.registerForm.maxPassword'), trigger: 'blur' }
        ],
        unPassword: [
          { required: true, message: this.$t('loginI18n.registerForm.unPassword'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('loginI18n.registerForm.maxPassword'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.registerForm.password) {
                callback(new Error(this.$t('loginI18n.registerForm.unPasswordError')));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ]
      },
      agree: false, // 同意协议
      countdown: 0, // 倒计时秒数
      registerLoading: false, // 注册按钮加载状态
      disabled: false,
      logoFormRef: null, // 登录表单引用
      registerFormRef: null, // 注册表单引用
      editType: "密码", // 编辑类型：手机、邮箱、密码
      validationType: "1", // 验证类型：手机:1、邮箱:2
      safeValiate: false,
      editValiate: false,
      newValidation: "", // 新的验证类型
      phoneOrEmail: "", // 手机号或邮箱
    };
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setToken', 'setShowLogin', 'setAccessType', 'setIstrial', 'setPermission', 'setSidebarExpanded']),

    // 处理同意协议的变化
    handleAgreeChange(checked) {
      if (checked) {
        this.agree = true;
      } else {
        this.agree = false;
      }
    },
    // 登录方法
    async loginFn() {
      this.disabled = true; // 开启加载状态
      this.$refs.logoFormRef.validate(valid => {
        if (!valid) {
          this.disabled = false; // 关闭加载状态
          return;
        }
        this.logoForm.phone = this.logoForm.phone.trim();
        this.logoForm.phone_msg = this.logoForm.phone_msg.trim();
        login({
          username: this.logoForm.phone,
          password: this.logoForm.phone_msg
        })
          .then(response => {
            if (response.data.code == 200) {
              const { token, ...userInfo } = response.data.data;
              this.$message.success(this.$t('loginI18n.logoForm.loginSuccess'));
              this.setUserInfo(userInfo);
              this.setToken(token);
              this.setSidebarExpanded(true)
              setTimeout(async () => {
                this.setShowLogin(false); // 关闭登录框
                this.$root.$emit('loginSuccess');
                if (this.accessType !== 'ai') {
                  // 当用户没有权限时，跳转到AI对话
                  const haveActive = await this.checkFeature(this.accessType);
                  if (haveActive == false) {
                    this.setAccessType('ai');
                    this.setPermission(true)
                    this.$root.$emit('login-success-and-check-feature'); // 👈 通知 Sidebar
                    // 在chatPage页面
                    if (this.$route.name === 'ChatPage') {
                      this.$emit('need-purchase', this.accessType);
                      this.$router.replace({ name: 'ChatPage', query: {} }).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                          console.error(err);
                        }
                      });
                    } else {
                      // 不在chatPage页面
                      this.$router.push({ name: 'ChatPage' });
                    }
                    return;
                  }
                }
                if (!this.isWecomePage) {
                  this.$emit('start-new-chat'); // 触发父组件事件
                } else {
                  this.$router.push({ name: 'ChatPage' });
                }
                if (userInfo.features.length == 0) {
                  // this.$parent.$refs.serviceDialog.showModal();
                  this.setIstrial(false); // 记录试用状态
                }
                // this.setAccessType('user'); // 设置访问类型为用户
                if (this.$route.name === 'ChatPage') {
                  this.$router.replace({ name: 'ChatPage', query: {} }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                      console.error(err);
                    }
                  });
                  this.$router.go(0);
                }
              }, 1500);
            } else if (response.data.code == 400) {
              handleLogout(); // 调用公共方法
              this.$message.error(response.data.data);
            } else {
              handleLogout(); // 调用公共方法
              this.$message.error(this.$t('loginI18n.logoForm.loginFailed'));
              return;
            }

          })
          .catch(error => {
            handleLogout(); // 调用公共方法
            this.$message.error(this.$t('loginI18n.logoForm.loginFailed'));
          });
      })
      this.disabled = false;
    },

    // 检查用户是否有访问某个功能的权限
    async checkFeature(t) {
      let features = "";
      if (this.userInfo?.user_name) {
        try {
          const response = await getAccount({
            user_id: this.userInfo?.user_id,
          });
          const { ...userInfo } = response.data.data;
          features = userInfo?.features?.some(f => f.code === t);
          this.setUserInfo(userInfo);
          return features;
        }
        catch (error) {
          this.$message.error(this.$t('accountI18n.getUserInfoError'));
        }
      }
    },

    // 注册方法
    register() {
      this.$refs.registerFormRef.validate(valid => {
        if (!valid) return;
        if (!this.agree) {
          this.$message.error(this.$t('loginI18n.registerForm.agree') + this.$t('loginI18n.registerForm.privacy'));
          return;
        }
        this.registerLoading = true; // 开启加载状态
        registerApi({
          user_name: this.registerForm.user_name,
          email: this.registerForm.email,
          company: this.registerForm.company,
          phone: this.registerForm.phone,
          security_code: this.registerForm.security_code,
          password: this.registerForm.password,
          url: this.referer, // 添加用户来源URL信息
        })
          .then((response) => {
            if (response.data.code == 200) {
              this.$message.success(this.$t('loginI18n.registerForm.registerSuccess'));
              // localStorage.removeItem('istrial'); //删除记录的申请试用缓存
              this.switchToLogin();
            } else {
              this.$message.error(response.data.data);
            }
            // this.$message.success('注册成功，请登录');
            // localStorage.removeItem('istrial'); //删除记录的申请试用缓存
            // this.switchToLogin();
          })
          .catch(error => {
            this.$message.error(error || this.$t('loginI18n.registerForm.registerFailed'));
          })
          .finally(() => {
            this.registerLoading = false; // 关闭加载状态
          });
      })
    },

    // 切换密码可见性
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    // 切换到注册窗口
    switchToRegister() {
      this.$refs.logoFormRef.clearValidate();
      this.show = false; // 隐藏登录窗口
      setTimeout(() => {
        this.showLogin = false; // 切换到注册窗口
        if (this.$refs.registerFormRef) {
          this.$refs.registerFormRef.clearValidate();
          this.$refs.registerFormRef.resetFields();
        }
        // this.show = true; // 显示注册窗口
      }, 300);
    },

    // 切换到登录窗口
    switchToLogin() {
      this.show = true; // 显示登录窗口
      setTimeout(() => {
        if (this.$refs.logoFormRef) {
          this.$refs.logoFormRef.clearValidate();
          this.$refs.logoFormRef.resetFields();
        }
        this.showLogin = true; // 切换到登录窗口
      }, 300);
    },

    // 关闭登录窗口
    close() {
      this.resetForms(); // 清空表单内容
      this.setShowLogin(false); // 调用 Vuex 方法关闭登录框
    },

    // 发送验证码
    startCountdown() {
      if (this.token) {
        this.setToken(null); // 清除之前的token,以防guestLogin注册后token未更新
      }
      const phoneRegex = /^1[3-9]\d{9}$/; // 11位手机号正则
      if (!this.registerForm.phone) {
        this.$message.error(this.$t('loginI18n.registerForm.phoneError'));
        return;
      }
      if (!phoneRegex.test(this.registerForm.phone)) {
        this.$message.error(this.$t('loginI18n.registerForm.phoneError'));
        return;
      }

      // 调用发送验证码 API
      sendVerifyCode({ phone: this.registerForm.phone })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(this.$t('loginI18n.registerForm.codeSendSuccess'));
            this.countdown = 60;
            const timer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--;
              } else {
                clearInterval(timer);
              }
            }, 1000);
          }else{
            this.$message.error(res.data.data);
          }
        })
        .catch(error => {
          this.$message.error(error || this.$t('loginI18n.registerForm.codeSendFailed'));
        });
    },

    // 清空表单内容
    resetForms() {
      this.$refs.logoFormRef.resetFields();
      if (this.$refs.registerFormRef) {
        this.$refs.registerFormRef.clearValidate();
        this.$refs.registerFormRef.resetFields();
      }
    },

    //截取url参数
    getQueryParam(url, param) {
      const regex = new RegExp(`[?&]${param}=([^&]+)`);
      const match = url.match(regex);
      return match ? decodeURIComponent(match[1]) : null;
    },

    // 跳转到隐私政策页面
    navigateTo(type) {
      const routes = {
        privacy: this.$router.resolve({ name: "Privacy" }).href,
      };
      const url = routes[type];
      if (url) {
        window.open(url, "_blank");
      }
    },

    // 忘记密码
    forgetPassword() {
      this.safeValiate = true;
    },

    //安全验证成功后更新用户信息
    onSafeValidateSuccess(data, value, phoneOrEmail) {
      this.safeValiate = false;
      this.editValiate = true;
      this.validationType = data;
      this.newValidation = value;
      this.phoneOrEmail = phoneOrEmail;
      console.log("修改类型：", this.editType);
    },
    //修改邮箱或手机成功后更新用户信息
    editSuccess() {
      this.editValiate = false;
      this.getUserInfo();
    }
  },
  mounted() {
    this.$emit('close-chat-list');
  },
  computed: {
    ...mapState(["token", "referer", "istrial", "accessType", "userInfo"]),
    isWecomePage() {
      return this.$route.name === 'WecomePage'; // 判断当前页面是否为 WecomePage
    },
  },
};
</script>

<style scoped>
#particles-js {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  /* 透明背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.login-overlay::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(44, 109, 82, 0.5);
  z-index: -1;
  /* 确保在内容下方 */
  backdrop-filter: blur(5px);
  /* 添加模糊效果 */
  -webkit-backdrop-filter: blur(5px);
  /* 兼容 WebKit 浏览器 */
}

.login-page {
  background: #fff;
  width: 482px;
  /* height: 630px; */
  height: 560px;
  border-radius: 20px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 水平垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1001;
}

.register-page {
  /* background: #fff; */
  background: radial-gradient(13.93% 24.39% at 33.56% -3.3%, #CEFFF5 0%, #F6FBF9 100%);
  width: 482px;
  height: 816px;
  border-radius: 20px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 水平垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1001;
}

.login-page_header {
  width: 386px;
  height: 326px;
  position: absolute;
  top: 100px;
  left: 48px;
}

.register-page_header {
  width: 257px;
  height: 145px;
}

.login-page_header img {
  width: 100%;
  height: 100%;
}

.register-page_header img {
  width: 100%;
  height: 100%;
}

.login-ruleForm {
  width: 346px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 297px;
  left: 67px;
}

.register-ruleForm {
  width: 346px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 300px;
  left: 67px;
}

::v-deep .login-ruleForm .el-input__prefix {
  line-height: 56px;
  left: 22px !important;
}

::v-deep .register-ruleForm .el-input__prefix {
  line-height: 45px;
  left: 22px !important;
}

::v-deep .login-ruleForm .el-input--prefix .el-input__inner,
::v-deep .register-ruleForm .el-input--prefix .el-input__inner {
  padding-left: 58px !important;
}

.login-form_user {
  width: 24px;
  height: 20px;
}

.login-form_company {
  width: 16px;
  height: 20px;
}

.login-form_email {
  width: 22px;
  height: 17px;
}

.login-form_view {
  width: 17px;
  height: 14px;
}

::v-deep .login-ruleForm .el-input__suffix {
  line-height: 50px;
  right: 12px !important;
  cursor: pointer;
}

::v-deep .register-ruleForm.el-input__suffix {
  line-height: 45px;
  right: 12px !important;
  cursor: pointer;
}

.login-form .el-form-item {
  width: 100%;
  margin-bottom: 17px;
}

.register-ruleForm .el-form-item {
  width: 100%;
  margin-bottom: 20px;
}

.el-icon-circle-close {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 32px;
  cursor: pointer;
  color: rgba(117, 117, 117, 1);
}

::v-deep .login-form .el-form-item__label,
::v-deep .register-ruleForm .el-form-item__label {
  color: rgba(117, 117, 117, 1);
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #000;
}

::v-deep .login-form .el-input {
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
}

::v-deep .register-ruleForm .el-input {
  width: 100%;
  height: 40px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
}

::v-deep .login-form .el-input__inner {
  border: none !important;
  border-radius: 16px !important;
  height: 46px !important;
  background: #fff !important;
  font-size: 16px !important;
}

::v-deep .register-ruleForm .el-input__inner {
  border: none !important;
  border-radius: 16px !important;
  height: 40px !important;
  background: #fff !important;
  font-size: 16px !important;
}

.register-page_code ::v-deep .el-input__inner {
  border-radius: 0 !important;
  box-shadow: 0px !important;
  border: none !important;
  background: transparent !important;
}

.forget_password {
  width: 100%;
  /* text-align: right; */
  font-size: 16px;
  color: rgba(32, 162, 255, 1);
  cursor: pointer;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
}

.login-form_button {
  width: 100%;
  display: flex;
  justify-content: center;
}

.login-form_info {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.login-form_button_btn {
  width: 160px;
  height: 50px;
  border-radius: 40px;
  font-size: 24px;
  border: none;
  letter-spacing: 10px;
  text-indent: 10px;
}

.noLetter {
  letter-spacing: 0px !important;
}

.login-form_button_btn:hover {
  background: rgba(51, 158, 158, 1);
  color: #fff;
}

.register-form_button_btn {
  width: 348px;
  height: 50px;
  font-size: 24px;
  border: none;
  letter-spacing: 10px;
  text-indent: 10px;
  border-radius: 16px;
  border: 1px solid var(--global-primary);
}

.register-form_button_btn:hover {
  background: var(--global-primary) !important;
  color: #fff;
}

.login {
  background: var(--global-primary) !important;
  color: #fff !important;
  font-weight: 700 !important;
  border-radius: 16px !important;
}

.register {
  background: #fff !important;
  color: var(--global-primary) !important;
  letter-spacing: 10px;
  text-indent: 10px;
  font-weight: 700 !important;
  border-radius: 16px !important;
  border: 1px solid var(--global-primary) !important;
}

.register:hover {
  background: #fff !important;
  color: var(--global-primary) !important;
}

.register-page_code {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-radius: 28px !important;
  background: #fff !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1) !important;
}

::v-deep .register-page_code .el-input {
  width: 200px !important;
  border-radius: none !important;
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

.register-page_code_btn {
  border: none;
  width: 140px !important;
  background: var(--global-light-gray) !important;
  color: #000 !important;
  font-size: 16px;
  border-radius: 16px;
  font-weight: 400 !important;
}

.register-page_code_btn:hover {
  background: rgba(204, 233, 178, 1);
  color: #000;
}

.hide-spin ::v-deep input::-webkit-outer-spin-button,
.hide-spin ::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 隐藏 Firefox 中的箭头 */
.hide-spin ::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

::v-deep .el-input__inner:-webkit-autofill {
  background-color: #ffffff !important;
  /*在这里换成你想要的颜色*/
  transition: background-color 5000s ease-in-out 0s !important;
}

::v-deep .el-input__inner:-webkit-autofill {
  background-color: #ffffff !important;
  /*在这里换成你想要的颜色*/
  transition: background-color 5000s ease-in-out 0s !important;
}

::v-deep .el-button:focus {
  background-color: rgba(51, 158, 158, 1);
  color: #fff;
}

/* 全局样式：将所有 el-checkbox 改为圆形 */
::v-deep .el-checkbox .el-checkbox__input .el-checkbox__inner {
  border-radius: 50%;
  /* 关键：将方形改为圆形 */
}

/* 选中状态的圆形样式优化 */
::v-deep .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: rgba(51, 158, 158, 1);
  border-color: rgba(51, 158, 158, 1);
}

/* 自定义勾选图标（可选） */
::v-deep .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner::after {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: white;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

::v-deep .el-checkbox .el-checkbox__inner::after {
  content: '';
  /* 清空内容 */
  display: none;
  /* 默认隐藏 */
}

::v-deep .el-checkbox.is-checked .el-checkbox__inner::after,
::v-deep .el-checkbox.is-indeterminate .el-checkbox__inner::after {
  display: block;
  /* 选中或半选时显示 */
}
</style>
